module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-mediumitalic-webfont.18a0bd1c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-mediumitalic-webfont.ttf
// module id = 379
// module chunks = 3